import { gql } from '@apollo/client';

export const GET_PRESIGNED_DOWNLOAD_URL = gql`
  query GetPreSignedDownloadUrl($input: PreSignedDownloadUrlInput!) {
    getPreSignedDownloadUrl(input: $input) {
      url
    }
  }
`;
